import React from 'react'
import { Typography } from '@chegg-ui/typography'
import Image from 'next/image'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { colors, spacing } from '@chegg-ui/theme'
import { navigated } from '@chegg-wt/core/state/app/actions'
import { useRoutesContext } from '@chegg-wt/core/components/RoutesContext'
import { useDispatch } from 'react-redux'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { ENTRY_BANNER_TEST_ID } from '@chegg-wt/core-wa/constants/paraphraser'
import { AIStarIcon } from '../icons/AIStarIcon'
import {
  ArrowIcon,
  BannerHeading,
  BannerHeadingContainer,
  BetaReleaseContainer,
  BetaReleaseText,
  EntryBanner,
  GetStartedButton,
  ImageContainer,
  TextSection,
} from './styled'

const PENCIL_ICON_WIDTH = 44
const PENCIL_ICON_HEIGHT = 44

export const EntryPointBanner = () => {
  const dispatch = useDispatch()
  const { toWritingAssistant } = useRoutesContext()

  const handleOnclick = () => {
    dispatch(
      userClick({
        origin: origins.writingAssistantBannerClick,
      })
    )
    dispatch(navigated(toWritingAssistant()))
  }

  return (
    <EntryBanner data-test={`${ENTRY_BANNER_TEST_ID}`}>
      <ImageContainer>
        <Image
          src={publicAssetUrl('IconPencil.svg')}
          alt="Keep Writing"
          width={PENCIL_ICON_WIDTH}
          height={PENCIL_ICON_HEIGHT}
        />
      </ImageContainer>

      <TextSection>
        <BannerHeadingContainer>
          <BannerHeading data-test={`${ENTRY_BANNER_TEST_ID}-heading`}>
            Help get your paper <span>hand-in</span> ready
          </BannerHeading>
          <BetaReleaseContainer>
            <BetaReleaseText>
              <AIStarIcon color={colors.violet600} size="x-small" />
              <span>AI-powered</span>
            </BetaReleaseText>
          </BetaReleaseContainer>
        </BannerHeadingContainer>
        <Typography
          variant="body1"
          variantType="normal"
          data-test={`${ENTRY_BANNER_TEST_ID}-text`}
        >
          Instant proofreading and paraphrasing to help you enhance your writing
        </Typography>
      </TextSection>

      <GetStartedButton
        width={spacing.px144}
        onClick={handleOnclick}
        data-test={`${ENTRY_BANNER_TEST_ID}-try-now-button`}
      >
        Try now <ArrowIcon />
      </GetStartedButton>
    </EntryBanner>
  )
}
